<template>
    <div>
        <h1 class="page-not-found">
            <u>Страницата не е намерена</u>
        </h1>
    </div>
</template>

<script>
    export default {
        name: "PageNotFound",
    }
</script>

<style scoped>
    .page-not-found {
        font-size: 40px; color: var(--dark-grey);
    }
</style>